import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-navigation',
  templateUrl: './user-navigation.component.html',
  styleUrls: ['./user-navigation.component.css']
})
export class UserNavigationComponent implements OnInit {
  showMenu: boolean = true;
  GuestName: string = "";

  constructor(private router: ActivatedRoute, private http: HttpClient, private Toaster: ToastrService, private route: Router) {
    // this.router.url.subscribe(segments => {
    //   const urlSegments = segments.map(segment => segment.path);
    //   if (urlSegments.includes('/user/dashboard')) {
    //     this.showMenu = false;
    //   }
    //   else {
    //     this.showMenu = true;
    //   }
    // });
  }

  ngOnInit() {
    this.GuestName = localStorage.getItem("GuestName") ? localStorage.getItem("GuestName") : localStorage.getItem("Email");
  }
  LogOut() {
    var LogId = localStorage.getItem("GuestLogID");
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = {
      headers: headers
    }
    this.http.get(environment.apiurlcore + 'api/user/logout?LogId=' + LogId, options).
      subscribe(
        (data: any) => {
          if (data.Status) {
            this.Toaster.success(data.Message, "", { timeOut: 2000 });
            localStorage.clear();
            this.route.navigate(['/online-services/login']);
          }
          else { this.Toaster.error(data.Message, "", { timeOut: 2000 }); }
        });
  }
}
